export default function getResource(label, vars = []) {
    const resources = {
        digitalProductFlashSubTitle: 'Livraison gratuite sans achat minimum pendant un an',
        digitalProductRewardsSubTitle: 'Échangez 2500 points contre une Récompense Rouge de 100 $',
        productNotFound: 'Produit non trouvé',
        subtitle: `Échangez ${vars[0]} points contre ${vars[1]} Récompense Rouge`
    };
    return resources[label];
}
